import React, { useState, useRef, useEffect } from "react";

const AvatarDropdown = ({ imgUrl }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggle = () => {
    setOpen(false);
  };

  return (
    <div className="dropdown" ref={dropdownRef}>
      <button
        className="btn btn-light d-flex align-items-center border-0 bg-transparent"
        onClick={() => setOpen(!open)}
      >
        <img
          src={imgUrl}
          alt="User Avatar"
          className="rounded-circle"
          width="40"
          height="40"
        />
      </button>

      {open && (
        <ul className="dropdown-menu show custom-dropdown-fix">
          <li onClick={handleToggle}>
            <a className="dropdown-item" href="/#">
              🚪 Logout
            </a>
          </li>
        </ul>
      )}
    </div>
  );
};

export default AvatarDropdown;
